import React from 'react';
function CategorySection() {
  const rules = [
    {
      id: 1,
      title: 'RULE 1',
      description:
        'Individual transaction over NGN 200,000 or cumulative daily transactions exceeding NGN 500,000.',
    },
    {
      id: 2,
      title: 'RULE 2',
      description:
        'Individual transaction over NGN 200,000 or cumulative daily transactions exceeding NGN 500,000.',
    },
    {
      id: 3,
      title: 'RULE 3',
      description:
        'Individual transaction over NGN 200,000 or cumulative daily transactions exceeding NGN 500,000.',
    },
  ];

  return (
    <div className="bg-white rounded-2xl h-full">
      {/* Empty state */}
      {/* <div className="flex items-center justify-center h-full">
        <div className="px-[95px] flex flex-col items-center justify-center">
          <img src={category} alt="category" className="mb-4" />
          <h3 className="text-black text-lg mb-1 text-center">
            No Category Selected
          </h3>
          <p className="text-[#868C98] text-tiny text-center">
            Click on view rules to see all the rules attached to a category
          </p>
        </div>
      </div> */}
      <div>
        <div className="p-6">
          <p className="  w-fit py-[5px] mb-2 px-3 bg-[#F2F6FE] rounded-full text-[#1E2254] font-medium text-small">
            Category
          </p>
          <h3 className="text-lg text-black">
            Low-Value Transaction Frequency
          </h3>
        </div>

        <div className="w-full h-[1px] bg-[#E1E4EA]" />

        <div className="p-6">
          <div className="bg-[#F2F6FE] py-4 px-6 rounded-2xl">
            {rules.map((rule, index) => (
              <React.Fragment key={rule.id}>
                <div className="space-y-2">
                  <p className="text-[#1E2254] font-semibold text-small   uppercase bg-white w-fit px-4 py-1 rounded-full">
                    {rule.title}
                  </p>
                  <p className="text-black font-medium text-base">
                    {rule.description}
                  </p>
                </div>
                {index < rules.length - 1 && (
                  <div className="w-full h-[1px] bg-[#E1E4EA] my-4" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategorySection;
